<script>
  import { createEventDispatcher } from "svelte";
  import AudioPlayback from "./AudioPlayback.svelte";

  // Recordings played before answering, in order (see promptAudioQueue). The
  // next one appears once the previous has played to the end or failed, so
  // an introduction is always heard before the question it leads into.
  export let queue = [];
  // Index of the recording being waited for; queue.length once all are heard.
  export let step = 0;
  export let maxPlays = 0;
  export let autoplay = false;
  // Play-button text per recording kind; AudioPlayback's default otherwise.
  export let labels = {};

  const dispatch = createEventDispatcher();
</script>

{#each queue as item, i (item.kind + ":" + item.src)}
  {#if i <= step}
    <div class="listen-media-center mt-2 mb-2">
      <AudioPlayback
        src={item.src}
        label={labels[item.kind]}
        {maxPlays}
        {autoplay}
        on:audioStarted
        on:audioEnded={() => dispatch("promptEnded", { index: i })}
        on:audioError={() => dispatch("promptFailed", { index: i })}
      />
    </div>
  {/if}
{/each}

<style>
  /* Same as the exercise page's own media rows. */
  .listen-media-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
    overflow-x: auto;
  }

  .listen-media-center.mt-2.mb-2 {
    margin-bottom: 16px !important;
  }
</style>
